import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import {
    ConfigurationSampleProcessPatchInBatchRequest,
    ConfigurationSampleProcessRequest,
    ConfigurationSampleProcessResponse
} from '@/modules/configurationModule/detail/automation/grossing-shelf/intermediate-shelf-process/services/configuration-sample-process/configuration-sample-process.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class ConfigurationSampleProcessService {
    async create(request: ConfigurationSampleProcessRequest): Promise<ConfigurationSampleProcessResponse> {
        const response = await axios.post<ConfigurationSampleProcessResponse>(`/configuration/sampleProcesses`, request)
        return response.data
    }

    async paginator(filterModel?: CommonFilterModel, params?: CommonParams): Promise<IResponseAgGrid<ConfigurationSampleProcessResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationSampleProcessResponse>>(`/configuration/sampleProcesses`, { ...filterModel }, { params })
        return response.data
    }

    async get(sampleProcessId: number): Promise<ConfigurationSampleProcessResponse> {
        const response = await axios.get<ConfigurationSampleProcessResponse>(`/configuration/sampleProcesses/${sampleProcessId}`)
        return response.data
    }

    async delete(request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/sampleProcesses/batch`, { data: request })
        return response.data
    }

    async patch(request: ConfigurationSampleProcessPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/sampleProcesses/batch`, request)
        return response.data
    }

    async search(query: string, params?: CommonParams): Promise<IResponseAgGrid<ConfigurationSampleProcessResponse>> {
        const response = await axios.get<IResponseAgGrid<ConfigurationSampleProcessResponse>>(`/configuration/sampleProcesses/search`, { params: { ...params, query } })
        return response.data
    }
}

export const configurationSampleProcessService = new ConfigurationSampleProcessService()
